module.exports = __webpack_public_path__ + "img/Deco_guinguette.4f79359.jpg";